const defaultDateFormat = 'dd.MM.yyyy';

export default defaultDateFormat;
